export default remote => ({
    passengers: (session) => remote.post(`user/passengers`, null, {params: {session}}),
    edit: (session, data) => remote.post(`user/passengers/edit`, data, {params: {session}}),
    delete: (session, data) => remote.post(`user/passengers/delete`, data, {params: {session}})
});
